import { render, staticRenderFns } from "./self_pause_settings.vue?vue&type=template&id=16679935&"
import script from "./self_pause_settings.vue?vue&type=script&lang=js&"
export * from "./self_pause_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports